import { useEffect, useState } from "react";
import axiosInstance from "../components/api/axiosInstance";
import { getCustomerSelectLabel, mapCustomerListItemFromApi } from "../utils/formatters";

let cache = null;
let pending = null;

function loadActiveTenants() {
  if (cache) return Promise.resolve(cache);
  if (!pending) {
    pending = axiosInstance
      .get("/clients", { params: { status: "Active" } })
      .then((res) => {
        const raw = Array.isArray(res.data) ? res.data : Array.isArray(res.data?.data) ? res.data.data : [];
        cache = raw
          .map(mapCustomerListItemFromApi)
          .filter(Boolean)
          .map((t) => ({ id: String(t.id), name: getCustomerSelectLabel(t) }))
          .sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: "base" }));
        return cache;
      })
      .finally(() => {
        pending = null;
      });
  }
  return pending;
}

/** Active tenants as [{id, name}] for staff "select tenant first" pickers (cached per page load). */
export default function useActiveTenants() {
  const [tenants, setTenants] = useState(() => cache || []);
  useEffect(() => {
    let cancelled = false;
    loadActiveTenants()
      .then((rows) => {
        if (!cancelled) setTenants(rows);
      })
      .catch(() => {
        if (!cancelled) setTenants([]);
      });
    return () => {
      cancelled = true;
    };
  }, []);
  return tenants;
}
